export default {
  // Split header context menu.
  newSplitLeft: 'New split left',
  newSplitRight: 'New split right',
  duplicateSplit: 'Duplicate split',
  swapSplitLeft: 'Swap split left',
  swapSplitRight: 'Swap split right',
  minimizeSplit: 'Minimize split',
  spotlightSplit: 'Spotlight split',
  closeSplit: 'Close split',
  closeOtherSplits: 'Close other splits',
  resetSizes: 'Reset sizes',
  copyDebugInfo: 'Copy debug info',
  toastDebugInfoCopied: 'Debug info copied to clipboard',
  toastCopyDebugInfoFailed: 'Failed to copy debug info',

  // Split header and drawer controls.
  goBack: 'Go Back',
  goForward: 'Go Forward',
  createNewSplit: 'Create new split',
  close: 'Close',
  returnToList: 'Return to list',
  previousItem: 'Previous item',
  nextItem: 'Next item',
  itemNavigation: 'Item navigation',
  openInThisSplit: 'Open in this split',
  closeReferencesDrawer: 'Close References Drawer',
  fileActions: 'File actions',
  untitled: 'Untitled',

  // Split permission badge.
  noAccess: 'No Access',
  commentOnly: 'Comment Only',
  viewOnly: 'View Only',
  badgeNoAccess: 'no access',
  badgeCommentOnly: 'comment only',
  badgeViewer: 'viewer',
};
